document.addEventListener('DOMContentLoaded', function() {
  function insertCartIcon() {
    // Target all "Add to Cart" buttons on the page
    const addToCartButtons = document.querySelectorAll('#product-add-to-cart');
    
    if (addToCartButtons.length > 0) {
      addToCartButtons.forEach(button => {
        // Check if the SVG is already present
        const existingSvg = button.querySelector('svg');
        
        // If there's no SVG, or it's not visible, add our custom one
        if (!existingSvg || window.getComputedStyle(existingSvg).display === 'none') {
          // First, check if we already added our custom icon
          if (!button.querySelector('.custom-cart-icon')) {
            // Create the SVG element
            const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svgElement.setAttribute('width', '17');
            svgElement.setAttribute('height', '16');
            svgElement.setAttribute('viewBox', '0 0 17 16');
            svgElement.setAttribute('fill', 'none');
            svgElement.setAttribute('class', 'custom-cart-icon');
            svgElement.style.marginRight = '8px';
            svgElement.style.display = 'inline-block';
            svgElement.style.verticalAlign = 'middle';
            
            // Create the path
            const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path.setAttribute('d', 'M1.16669 0.666748H3.83335L5.62002 9.59342C5.68098 9.90035 5.84796 10.1761 6.09172 10.3723C6.33548 10.5685 6.64049 10.6727 6.95335 10.6667H13.4334C13.7462 10.6727 14.0512 10.5685 14.295 10.3723C14.5387 10.1761 14.7057 9.90035 14.7667 9.59342L15.8334 4.00008H4.50002M7.16669 14.0001C7.16669 14.3683 6.86821 14.6667 6.50002 14.6667C6.13183 14.6667 5.83335 14.3683 5.83335 14.0001C5.83335 13.6319 6.13183 13.3334 6.50002 13.3334C6.86821 13.3334 7.16669 13.6319 7.16669 14.0001ZM14.5 14.0001C14.5 14.3683 14.2015 14.6667 13.8334 14.6667C13.4652 14.6667 13.1667 14.3683 13.1667 14.0001C13.1667 13.6319 13.4652 13.3334 13.8334 13.3334C14.2015 13.3334 14.5 13.6319 14.5 14.0001Z');
            path.setAttribute('stroke', 'currentColor');
            path.setAttribute('stroke-width', '1.6');
            path.setAttribute('stroke-linecap', 'round');
            path.setAttribute('stroke-linejoin', 'round');
            
            // Add path to SVG
            svgElement.appendChild(path);
            
            // Add SVG at the beginning of the button
            button.insertBefore(svgElement, button.firstChild);
            
            // Make button display flex to ensure alignment
            button.style.display = 'flex';
            button.style.alignItems = 'center';
            button.style.justifyContent = 'center';
          }
        }
      });
    }
  }
  
  // Run on page load
  insertCartIcon();
  
  // Also run when the DOM changes (useful for dynamic content)
  const observer = new MutationObserver(function(mutations) {
    insertCartIcon();
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
});
